export default __webpack_public_path__ + "static/media/two.6b061eb7.svg";